module.exports = __webpack_public_path__ + "static/media/SW_MA13-neu-orbit1_pos_rgb.5e8e8015.png";